import { Cents } from './../../../shared/core';
import { TokenSize }                  from './../../../shared-gen/Model/Vouchers/Token/TokenSize';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {environment}                  from '../../../environments/environment';
import {AppStatusService}             from '../../services/app-status.service';
import {Subscription}                 from 'rxjs';
import {ApiService}                   from '../../services/api.service';
import {ServingState}                 from '../../../shared-gen/Machine/Status/ServingState';
import {Medium}                       from '../../../shared-gen/Model/Financial/Medium';
import {DoorState}                    from '../../../shared-gen/Model/Devices/DoorState';
import {Door}                         from '../../../shared-gen/Model/Devices/Door';
import {VmcState}                     from '../../../shared-gen/Vending/Status/VmcState';
import { OpState }                    from "../../../shared-gen/Machine/Status/OpState";

@Component({
	selector: 'kkb-dummy',
	templateUrl: './debug.component.html',
	styleUrls: ['./debug.component.scss']
})
export class DebugComponent implements OnInit, OnDestroy {

	isDummy = false;
	version = environment.appVersion;
	vmcState = VmcState.Intervention;
	servingState?: ServingState = null;
	isMaintenance = false;

	private statusListener: Subscription;

	constructor(
		private api: ApiService,
		private appStatusService: AppStatusService) {
	}

	async ngOnInit() {
		// Listen to status changes
		this.statusListener = this.appStatusService.appStatus.subscribe(status => {
			const device = status.deviceStatus;
			// Show or hide dependent on Debug flag in config
			this.isDummy = device.UIConfig.Debug;
			// Update status
			if (device.VendingStatus != null) {
				this.vmcState = device.VendingStatus.VmcState;
				const servingStatus = device.MachineStatus.ServingStatus;
				this.servingState = servingStatus != null ? servingStatus.State : null;
				this.isMaintenance = device.MachineStatus.OpState === OpState.Maintenance;
			}
		});
	}

	ngOnDestroy() {
		if (this.statusListener)
			this.statusListener.unsubscribe();
	}

	async plusHardCash(cents: Cents) {
		await this.api.debugApi.payAmount(cents, Medium.HardCash);
	}

	async plusSaniFair() {
		await this.api.debugApi.paySaniFair();
	}

	async plusToken(size: string | TokenSize) { // string needed for HTML template
		await this.api.debugApi.payToken(size as TokenSize);
	}

	async refilled() {
		await this.api.machineApi.refilled();
	}

	detectCup() {
		// TODO @Andi
	}

	intervention() {
		// TODO @Andi
	}

	removeProduct() {
		this.api.machineApi.removed();
	}

	async setMaintenance(on: boolean) {
		await this.api.debugApi.setOpState(on ? OpState.Maintenance : OpState.Ready);
	}

	reload() {
		window.location.reload();
	}

	async setHaccpError() {
		await this.api.machineApi.setProblem("HACCP", true);
	}

	async setIntervention() {
		await this.api.debugApi.setIntervention();
	}
}
